import React from 'react';
import PropTypes from 'prop-types';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import Check from 'lucide-react/dist/esm/icons/check';
import { cn } from '~/lib/utils';

const HIDDEN_INPUT_STYLE = {
	position: 'absolute',
	width: '1px',
	height: '1px',
	padding: 0,
	margin: '-1px',
	overflow: 'hidden',
	clip: 'rect(0,0,0,0)',
	whiteSpace: 'nowrap',
	border: 0
};

const Checkbox = React.forwardRef(({ className, checked, defaultChecked, ...props }, ref) => (
	<>
		<CheckboxPrimitive.Root
			ref={ref}
			checked={checked}
			defaultChecked={defaultChecked}
			className={cn('peer inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-[2px] border border-input bg-background shadow outline-none active:border-primary active:ring-0 focus:border-primary focus:outline-none focus:ring-0 focus-visible:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-transparent data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground', className)}
			style={{ borderRadius: '2px', WebkitTapHighlightColor: 'transparent' }}
			{...props}
		>
			<CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
				<Check className="h-3.5 w-3.5" />
			</CheckboxPrimitive.Indicator>
		</CheckboxPrimitive.Root>
		<input
			type="checkbox"
			aria-hidden="true"
			tabIndex={-1}
			readOnly
			checked={checked === true || checked === 'indeterminate' ? true : !!checked || !!defaultChecked}
			style={HIDDEN_INPUT_STYLE}
		/>
	</>
));

Checkbox.displayName = CheckboxPrimitive.Root.displayName;
Checkbox.propTypes = {
	className: PropTypes.string,
	checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['indeterminate'])]),
	defaultChecked: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['indeterminate'])])
};

export { Checkbox };
